import script from "./Editstock.vue?vue&type=script&setup=true&lang=js"
export * from "./Editstock.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__